import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'kr-wallet-card-empty',
  templateUrl: './wallet-card-empty.component.html',
  styleUrls: ['./wallet-card-empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletCardEmptyComponent {
  large = input<boolean, unknown>(undefined, { transform: booleanAttribute });
}
